
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Admin from "../pages/admin/page";
import MasterAdmin from "../pages/master-admin/page";
import Register from "../pages/register/page";
import Login from "../pages/login/page";
import ForgotPassword from "../pages/forgot-password/page";
import ResetPassword from "../pages/reset-password/page";
import DonationDetail from "../pages/donation-detail/page";
import ShelterDetail from "../pages/shelter-detail/page";
import ShelterEvents from "../pages/shelter-events/page";
import AdoptionDetail from "../pages/adoption-detail/page";
import EventDetail from "../pages/event-detail/page";
import EventStatistics from "../pages/event-statistics/page";
import MisionHuellitas from "../pages/mision-huellitas/page";
import Tienda from "../pages/tienda/page";
import ProductoDetalle from "../pages/producto-detalle/page";
import HuellitasPerdidas from "../pages/huellitas-perdidas/page";
import Success from "../pages/success/page";
import Cancel from "../pages/cancel/page";
import ConfirmEmail from "../pages/confirm-email/page";
import PlanSelection from "../pages/plan-selection/page";
import Pricing from "../pages/pricing/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/master-admin",
    element: <MasterAdmin />,
  },
  {
    path: "/mision-huellitas",
    element: <MisionHuellitas />,
  },
  {
    path: "/tienda",
    element: <Tienda />,
  },
  {
    path: "/producto/:id",
    element: <ProductoDetalle />,
  },
  {
    path: "/huellitas-perdidas",
    element: <HuellitasPerdidas />,
  },
  {
    path: "/donation/:id",
    element: <DonationDetail />,
  },
  {
    path: "/shelter/:id",
    element: <ShelterDetail />,
  },
  {
    path: "/shelter/:id/events",
    element: <ShelterEvents />,
  },
  {
    path: "/event/:eventId",
    element: <EventDetail />,
  },
  {
    path: "/event/:eventId/statistics",
    element: <EventStatistics />,
  },
  {
    path: "/adoption/:id",
    element: <AdoptionDetail />,
  },
  {
    path: "/success",
    element: <Success />,
  },
  {
    path: "/cancel",
    element: <Cancel />,
  },
  {
    path: "/confirm-email",
    element: <ConfirmEmail />,
  },
  {
    path: "/plan-selection",
    element: <PlanSelection />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;